module.exports = __webpack_public_path__ + "img/menu-billing-payments.d2b63821.svg";